'use client';

import type { CommunityPost } from '@/lib/community/types';
import { PostCard } from './post-card';

// type PreviewMode = 'feed' | 'detail';

/**
 * PublishDetailPreview — read-only preview panel.
 * Shows the PostCard as it appears in the feed.
 */
export function PublishDetailPreview({ post }: { post: CommunityPost; hasRealCover?: boolean }) {
	// const [mode, setMode] = useState<PreviewMode>('feed');

	return (
		<div
			className="liquid-glass-panel w-[340px] shrink-0 overflow-hidden rounded-2xl flex flex-col transition-all duration-300 shadow-sm"
			style={{ background: 'white' }}
		>
			{/* Header */}
			<div className="px-4 pt-4 pb-2">
				<span className="text-xs text-foreground font-medium">预览</span>
			</div>

			{/* Preview content */}
			<div className="flex-1 overflow-y-auto">
				<div className="p-4 pointer-events-none">
					<PostCard post={post} />
				</div>
			</div>
		</div>
	);
}

// ── Detail preview (commented out, may be used later) ──
// Re-enable by:
// 1. Uncomment PreviewMode type above
// 2. Uncomment useState and tab switcher in the component
// 3. Uncomment DetailPreviewBody below and the detail branch in the render

// import { Heart, MessageCircle, Bookmark, Share2, Clock, ImageIcon } from 'lucide-react';
// import { relativeTime } from '@/lib/community/utils';
// import { AbilityTypeBadge } from './ability-type-badge';
// import { PostMarkdown } from './post-markdown';
// import { CoverImageAdaptive } from './cover-image-adaptive';
// import { AuthorCard } from './author-card';
//
// function DetailPreviewBody({ post, hasRealCover }: { post: CommunityPost; hasRealCover?: boolean }) {
// 	return (
// 		<div className="bg-white rounded-2xl overflow-hidden">
// 			{hasRealCover && post.coverImage ? (
// 				<CoverImageAdaptive alt={post.title} src={post.coverImage} />
// 			) : (
// 				<div className="w-full h-16 bg-foreground/[0.02] flex items-center justify-center border-b border-border/5">
// 					<ImageIcon className="h-4 w-4 text-foreground/[0.08]" />
// 				</div>
// 			)}
// 			<div className="px-6 pt-8 pb-2">
// 				<div className="flex flex-col items-center mb-6">
// 					<div className="flex items-center gap-3 mb-4">
// 						<AbilityTypeBadge size="sm" type={post.abilityType} />
// 						<span className="text-xs text-muted-foreground/60 flex items-center gap-1">
// 							<Clock className="h-3 w-3" />
// 							{relativeTime(post.createdAt)}
// 						</span>
// 					</div>
// 					<h1 className="text-xl sm:text-2xl font-bold text-foreground leading-snug text-center max-w-[640px] tracking-tight">{post.title || '标题预览'}</h1>
// 				</div>
// 				<div className="mb-6 flex justify-center">
// 					<AuthorCard authorId={post.author.id} />
// 				</div>
// 			</div>
// 			<div className="px-6 sm:px-10 md:px-16 lg:px-20">
// 				<div className="mb-8 mx-auto max-w-[660px] post-detail-prose">
// 					<PostMarkdown content={post.description || '正文预览...'} />
// 				</div>
// 				{post.tags.length > 0 && (
// 					<div className="mb-5 mx-auto max-w-[660px]">
// 						<div className="flex flex-wrap gap-2 justify-center">
// 							{post.tags.map((tag) => (
// 								<span className="text-caption bg-secondary/70 text-foreground/80 px-2.5 py-1 rounded-full" key={tag}>
// 									#{tag}
// 								</span>
// 							))}
// 						</div>
// 					</div>
// 				)}
// 			</div>
// 			<div className="px-6">
// 				<div className="flex items-center justify-between py-4 border-y border-border/30 mb-6 mx-auto max-w-[660px]">
// 					<div className="flex items-center gap-1">
// 						<span className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs text-muted-foreground">
// 							<Heart className="h-3.5 w-3.5" />
// 							{post.stats.likes}
// 						</span>
// 						<span className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs text-muted-foreground">
// 							<Bookmark className="h-3.5 w-3.5" />
// 							收藏
// 						</span>
// 						<span className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs text-muted-foreground">
// 							<Share2 className="h-3.5 w-3.5" />
// 							分享
// 						</span>
// 						<span className="flex items-center gap-1.5 px-3 py-1.5 text-xs text-muted-foreground">
// 							<MessageCircle className="h-3.5 w-3.5" />
// 							{post.stats.comments}
// 						</span>
// 					</div>
// 				</div>
// 			</div>
// 			<div className="px-6">
// 				<div className="mx-auto max-w-[660px] pb-6">
// 					<div className="py-6 text-center">
// 						<p className="text-xs text-muted-foreground/40">评论区预览</p>
// 					</div>
// 				</div>
// 			</div>
// 		</div>
// 	);
// }
